var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oferta.possuiVariacao)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":"","color":"secondary"}},on),[_vm._v("mdi-grid")])]}}],null,false,1105676531)},[_c('span',[_vm._v("Esta oferta possui grade de variação")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }